import { AbstractInterface } from './AbstractInterface';
import { performanceMonitorService } from '../../../../service/performance-monitor';

export class MonitoringLoggingQueue extends AbstractInterface {

  static flush(): Promise<any> {
    return Promise.all([
      performanceMonitorService.flush(),
    ]).catch(() => { // eslint-disable-line arrow-body-style
      // ignore all errors which could happen and return
      // a successful promise to continue the logout process
      return Promise.resolve();
    });
  }

}
